import { CartLine } from '@next/core-lib/cart';

import { CartComponent } from '../../cart.component';

export const createQuantityUnitSuffixArray = (componentRef: CartComponent): string[] => componentRef.cart?.lines?.map(createQuantityUnitSuffix) ?? [];

const createQuantityUnitSuffix = (cartLine: CartLine): string =>
  cartLine.orderingInformation.orderUnit ? `unit.${cartLine.orderingInformation.orderUnit}` : '';
